import React, { Component } from "react";
import { connect } from "react-redux";
import AdditionalMaterials from "../components/AdditionalMaterials";
import { updateUserData } from "../../../../actions/user.actions";

class AdditionalMaterialsContainer extends Component {
  constructor(props) {
    super(props);
    this.memberId = this.props.match.params.memberId;
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(data) {
    if (!this.memberId) {
      this.props.updateUserData(data, "/member/profile", "additionalMaterials");
    } else {
      const url = /(5|6|7|9)/.test(this.props.user.status_id)
        ? `/admin/member/${this.memberId}/moderation`
        : `/admin/member/approved/${this.memberId}/profile`;

      this.props.updateUserData(data, url, "additionalMaterials");
    }
  }

  render() {
    return (
      <AdditionalMaterials
        onSubmit={this.handleSubmit}
        links={this.props.links}
        memberId={this.memberId}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    links: state.user.data.links,
    user: state.user.data
  };
};

const mapDispatchToProps = dispatch => ({
  updateUserData: (user, redirect, formName) =>
    dispatch(updateUserData(user, redirect, formName))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdditionalMaterialsContainer);



// WEBPACK FOOTER //
// ./src/routes/candidate/profile/containers/AdditionalMaterialsContainer.js